import { h } from '@jsx6/jsx6'
import { ScreenType } from './ScreenType.js'

/**
 * 
 * @param {Element} body 
 * @returns {ScreenType} screenType
 */
export const initScreenType = (body) => {
  const {width, height} = window.screen
  let smaller = Math.min(width, height)
  let larger = Math.max(width, height)
  let screenType = {} as ScreenType
  if (smaller < 680) {
    screenType.code = 'phone'
    screenType.Phone = true
  } else if (larger < 1100) {
    screenType.Tablet = true
    screenType.code = 'tablet'
  } else {
    screenType.Desktop = true
    screenType.code = 'desktop'
  }
  screenType.Mobile = screenType.Phone || screenType.Tablet

  body.setAttribute('screenType', screenType.code)
  body.setAttribute('buttons-size', screenType.code == 'desktop' ? 'desktop' : 'mobile')
  body.setAttribute('class', screenType.Mobile? 'mobileBody' : '')
  return screenType
}
